import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          maxHeight="750px"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          alignCenter
        >
          <CFView textCenter w="100%">
            <CFView mt="30px">
              <CFImage
                w="90%"
                src={mobileHeroText}
                alt="KrunChicken Bar hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mt="20px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="650px"
          maxWidth="1400px"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
          pl="5%"
        >
          <CFImage
            w="100%"
            maxWidth="620px"
            src={heroText}
            alt="KrunChicken Bar hero text"
            zIndex={98}
          />
          <CFView mt="30px" pulsate>
            <OrderPickupButton />
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
